module.exports = __webpack_public_path__ + "static/logo-4e3718c343910e5988c0e4da62aab162.png";